export const FORM_UPDATE = "FORM_UPDATE"
export const FORM_CLEAR = "FORM_CLEAR"
export const ADD_ZONE_FORM = "ADD_ZONE_FORM"
export const CLEAR_ZONE_FORM = "CLEAR_ZONE_FORM"